import React, { useState, useEffect } from "react";
import { Grid, TextField, MenuItem, Typography, makeStyles } from "@material-ui/core";
import { toast } from "react-toastify";
import api from "../../services/api";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}));

const CampaignTemplateStep = ({ campaign, onChange }) => {
    const classes = useStyles();
    const [templates, setTemplates] = useState([]);

    useEffect(() => {
        fetchTemplates();
    }, []);

    const fetchTemplates = async () => {
        try {
            const { data } = await api.get("/email-templates"); // Assumindo endpoint de listagem
            // Adjust structure based on actual API response (might need .templates or be array)
            const templateList = data.templates || data;
            setTemplates(templateList);
        } catch (err) {
            toast.error("Erro ao carregar templates.");
        }
    };

    return (
        <div className={classes.root}>
            <Typography variant="h6" style={{ marginBottom: 20 }}>
                Mensagem da Campanha
            </Typography>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        label="Assunto do E-mail"
                        variant="outlined"
                        value={campaign.subject || ""}
                        onChange={(e) => onChange("subject", e.target.value)}
                        required
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        select
                        fullWidth
                        label="Selecione o Template"
                        variant="outlined"
                        value={campaign.templateId || ""}
                        onChange={(e) => onChange("templateId", e.target.value)}
                        required
                    >
                        {templates.map((template) => (
                            <MenuItem key={template.id} value={template.id}>
                                {template.name}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            </Grid>
        </div>
    );
};

export default CampaignTemplateStep;
